import { render, staticRenderFns } from "./ChoiceSingle.vue?vue&type=template&id=c48a90b8&"
import script from "./ChoiceSingle.vue?vue&type=script&lang=js&"
export * from "./ChoiceSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports